<template>
    <div>
        <p class="modal-heading">Raise an issue</p>
        <textarea class="form-control note mt-4" placeholder="Optionally add a note to explain this issue" v-model="note"></textarea>

        <div class="d-flex align-items-center mt-45">
            <button :disabled="loading" @click="send()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 w-50 justify-content-center align-items-center" :class="{disabled : loading}">Send <span v-if="loading" class="btn-loading"></span></button>
            <button :disabled="loading" @click="close()" class="btn btn-danger btn-lg lg-shadow d-flex flex-grow-1 w-50 ml-3 justify-content-center align-items-center" :class="{disabled : loading}">Cancel</button>
        </div>

        <div v-if="error" class="alert alert-danger mt-4">
            Sorry, something went wrong. Please try again.
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapActions} from 'vuex'
export default {
    name: 'RaiseIssueModalComponent',

    props: {
        organisationId: String,
        test: Object
    },

    data() {
        return {
            loading: false,
            error: false,
            note: null
        }
    },

    methods: {
        ...mapActions({
            setNotification: 'NotificationStore/SetNotification'
        }),

        async send() {
            this.loading = true 
            this.error = false

            try {
                await axios.patch(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/tests/${this.organisationId}/${this.test.id}/report`, {
                    reason: this.note
                })

                this.test.status = 5

                this.setNotification({
                    type: 'success',
                    title: 'Success',
                    message: 'The test has been marked as reported'
                })

                this.$emit('close')
                return this.$router.push({name: 'Dashboard'})
            }
            catch {
                this.error = true
            }
            finally {
                this.loading = false
            }
        },

        close() {
            this.$emit('close')
        }
    }
}
</script>